import { useState } from 'react';
import './ForgotPassword.css';
import { PasswordResetRequest } from './Requests';
import { PulseLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

const RequestForgotPassword = () => {
  const { t } = useTranslation('auth');

  const [email, setEmail] = useState('');
  const [canSend, setCanSend] = useState(false);
  const [status, setStatus] = useState('enter'); // 'enter' | 200 | 400
  const [isLoading, setIsLoading] = useState(false);

  function onSendResetLink(e) {
    e.preventDefault();

    if (!email) return;

    setIsLoading(true);
    PasswordResetRequest(email.toLowerCase())
      .then((res) => {
        if (res.status === 200) {
          setStatus(200);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 400) {
          setStatus(400);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function onEmailChange(value) {
    const v = (value ?? '').trim();
    setEmail(v);
    setCanSend(!!v);
  }

  return (
    <div className="login-background">
      <div className="login-container">
        <div style={{ justifyContent: 'center', display: 'flex' }}>
          <PulseLoader
            color={'#333'}
            loading={isLoading}
            size={25}
            aria-label={t('forgot.loadingAria')}
            data-testid="loader"
          />
        </div>

        {status === 'enter' && !isLoading ? (
          <div className="login-form">
            <h1 className="login-title">{t('forgot.title')}</h1>
            <form className="login-form" onSubmit={onSendResetLink}>
              <div style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <p className="login-subtitle" style={{ marginBottom: '0.5rem', marginTop: '1rem' }}>
                  {t('forgot.email.label')}
                </p>
              </div>
              <input
                type="email"
                onChange={(e) => onEmailChange(e.target.value)}
                style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}
                id="email"
                placeholder={t('forgot.email.placeholder')}
                required
              />
              <button className="signin-btn" onClick={onSendResetLink} disabled={!canSend}>
                {t('forgot.actions.sendLink')}
              </button>
            </form>
          </div>
        ) : status === 400 && !isLoading ? (
          <div style={{ textAlign: 'center' }}>
            <h1>{t('forgot.error.title')}</h1>
            <p>{t('forgot.error.invalidEmail')}</p>
          </div>
        ) : status === 200 && !isLoading ? (
          <div style={{ textAlign: 'center' }}>
            <h1>{t('forgot.success.title')}</h1>
            <p>{t('forgot.success.description')}</p>
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

export default RequestForgotPassword;
